module.exports = __webpack_public_path__ + "images/white-arrow-right.svg";